// Fired on window when a push reaches an open Qluu page, so live views can re-check.
export const PUSH_RECEIVED_EVENT = 'qluu:push-received';
